import { initProductBuyTile } from '../../../snippets/product-buy-tile-control/product-buy-tile-control';

export const initPoeControlsSectionTiles = () => {
  const controlProductEls = document.querySelectorAll(
    '[data-list-collections-poe-controls-product]'
  );

  controlProductEls.forEach((productEl) => {
    const productId = productEl.getAttribute(
      'data-list-collections-poe-controls-product'
    );

    if (productId) {
      initProductBuyTile(productId, { isPOEProduct: true });
    }
  });
};
